import {mapActions} from "vuex";
import {createPinia, PiniaVuePlugin} from "pinia";

window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');

Vue.use(PiniaVuePlugin)
const pinia = createPinia();

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

Vue.use(VueToast, {
  duration: 5000,
  position: 'top-right'
})

import VShowSlide from 'v-show-slide';

Vue.use(VShowSlide);

import VueNumberInput from '@chenfengyuan/vue-number-input';

Vue.component('dentaid-number-input', VueNumberInput);

import VueYoutube from 'vue-youtube';

Vue.use(VueYoutube);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar, {options: {'wheelPropagation': false, 'suppressScrollX': true}});

Vue.component('dentaid-tabs-component', require('../vue/components/TabsComponent').default);
Vue.component('dentaid-tab-button', require('../vue/components/TabButton').default);
Vue.component('dentaid-accordion', require('../vue/components/Accordion').default);
Vue.component('dentaid-product-components-wrapper', require('../vue/components/ProductComponentsWrapper').default);
Vue.component('dentaid-product-price', require('../vue/components/ProductPrice').default);
Vue.component('dentaid-product-quantity', require('../vue/components/ProductQuantity').default);
Vue.component('dentaid-add-to-cart', require('../vue/components/AddToCart').default);
Vue.component('dentaid-product-favorite', require('../vue/components/ProductFavorite').default);
Vue.component('dentaid-tooltip', require('../vue/components/Tooltip').default);
Vue.component('dentaid-youtube-wrapper', require('../vue/components/YoutubeWrapper').default);
Vue.component('dentaid-cart-badge', require('../vue/components/CartBadge').default);
Vue.component('dentaid-alert-block', require('../vue/components/DentaidAlertBlock').default);
Vue.component('dentaid-product-teaser', require('../vue/components/ProductTeaser.vue').default)
Vue.component('dentaid-related-product-slider-wrapper', require('../vue/components/RelatedProductSliderWrapper.vue').default)
Vue.component('dentaid-related-product-slide', require('../vue/components/RelatedProductSlide.vue').default)

//Mediamap
Vue.component('dentaid-mediamap-accordion', require('../vue/components/Mediamap/MediaAccordion').default);

// CHECKOUT
Vue.component('dentaid-cart-component-wrapper', require('../vue/components/checkout/CartComponentWrapper').default);
Vue.component('dentaid-cart-table', require('../vue/components/checkout/CartTable').default);
Vue.component('dentaid-cart-row', require('../vue/components/checkout/CartRow').default);
Vue.component('dentaid-checkout-confirm-wrapper', require('../vue/components/checkout/CheckoutConfirmWrapper').default);
Vue.component('dentaid-delivery-datepicker', require('../vue/components/checkout/DeliveryDatepicker').default);
Vue.component('dentaid-mini-cart', require('../vue/components/checkout/CheckoutMiniCart').default);
Vue.component('dentaid-mini-cart-item', require('../vue/components/checkout/MiniCartItem').default);

// SVG's
Vue.component('dentaid-logo-etos', require('../vue/components/svg/LogoEtos').default);
Vue.component('dentaid-logo-vitis', require('../vue/components/svg/LogoVitis').default);
Vue.component('dentaid-logo-plein', require('../vue/components/svg/LogoPlein').default);
Vue.component('dentaid-logo-farmaline', require('../vue/components/svg/LogoFarmaline').default);
Vue.component('dentaid-gift-icon', require('../vue/components/svg/GiftIcon').default);
Vue.component('dentaid-consumer-icon', require('../vue/components/svg/ConsumerIcon').default);
Vue.component('dentaid-loader', require('../vue/components/svg/Loader').default);
Vue.component('dentaid-favorite-icon', require('../vue/components/svg/FavoriteIcon').default);
Vue.component('dentaid-expected-order-icon', require('../vue/components/svg/ExpectedOrderIcon').default);
Vue.component('dentaid-last-order-icon', require('../vue/components/svg/LastOrderIcon').default);
Vue.component('dentaid-reorder-icon', require('../vue/components/svg/ReorderIcon').default);
Vue.component('dentaid-trash-icon', require('../vue/components/svg/TrashIcon').default);
Vue.component('dentaid-logo-finder', require('../vue/components/svg/LogoFinder').default);

// Enhanced Ecommerce
Vue.component('dentaid-ec-product-impressions', require('../vue/components/EnhancedEcommerce/ProductImpressions').default);
Vue.component('dentaid-ec-product-detail-view', require('../vue/components/EnhancedEcommerce/ProductDetailView').default);

Vue.component('dentaid-homepage-user-buttons', require('../vue/components/HomepageUserButtons.vue').default);
Vue.component('dentaid-account-orders', require('../vue/components/AccountOrders').default);
Vue.component('dentaid-account-favorites', require('../vue/components/AccountFavorites').default);
Vue.component('dentaid-product-teaser-wrapper', require('../vue/components/ProductTeaserWrapper').default);

Vue.component('dentaid-area-manager-finder', require('../vue/components/AreaManagerFinder').default);

let dentaidApi = '';

if (!lodash.isNil(drupalSettings.ef2_custom)) {
  dentaidApi = axios.create({
    baseURL: drupalSettings.ef2_custom.api_url
  });
}

import store from './store/store.js';
import {usePiniaStore} from "./store/pinia_store";
import {isEmpty} from "lodash";

new Vue({
  el: '#page-wrapper',

  comments: true,

  data() {
    return {
      dentaidApi,
      cartEventBus: new Vue(),
      eventBus: new Vue(),
      jwtToken: '',
      customerNumber: drupalSettings.ef2_custom.customer_number
    }
  },

  created() {
    const piniaStore = usePiniaStore();
    piniaStore.getUserData();
  },

  methods: {
    ...mapActions(['fetchFavorites']),
  },

  store,
  pinia
});
